import React, { FC, useCallback, useEffect } from 'react';

import { postMessageRN, runningInRNWebView, SignEvent, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';
import { OpenBrowserCallbackEvent } from '@eika-infrastruktur/mobilbank-lib/src/nativeEvents';

import { cancelPayment } from '../services/paymentService';
import BankIdSigning from './BankIdSigning';
import { useSigningContext } from './signingContext';
import useSigningContextResult from './useSigningContextResult';

export interface Props extends React.PropsWithChildren {
    onClosePayment?: () => void;
    // @default 'Godkjenn'
    title?: string;
}

const SigningContextFlow: FC<Props> = ({ children, onClosePayment = Function, title }) => {
    const { cancelSigning } = useSigningContextResult(onClosePayment);
    const { dynamicLinkId, redirectUri, showSigningFlow, signingStatus, bankIDOnly } = useSigningContext();
    useEffect(() => {
        if (showSigningFlow && runningInRNWebView && dynamicLinkId?.value && signingStatus === 'CREATED') {
            if (bankIDOnly) {
                postMessageRN({
                    action: WebToRNAction.OPEN_BROWSER_CALLBACK,
                    payload: { uri: redirectUri, callbackResultPrefix: 'signingresult/' } as OpenBrowserCallbackEvent,
                });
            } else {
                postMessageRN({
                    action: WebToRNAction.SIGN,
                    payload: { bankIdUri: redirectUri, dynamicLinkId: dynamicLinkId.value } as SignEvent,
                });
            }
        }
    }, [dynamicLinkId?.value, signingStatus, redirectUri, showSigningFlow, bankIDOnly]);

    const onCancelPaymentCallback = useCallback(() => {
        if (dynamicLinkId?.value && signingStatus && ['CREATED', 'PROCESSING'].includes(signingStatus)) {
            cancelPayment(dynamicLinkId);
        }
        cancelSigning();
    }, [cancelSigning, dynamicLinkId, signingStatus]);

    if (!runningInRNWebView && redirectUri && showSigningFlow) {
        return <BankIdSigning signUri={redirectUri} cancelSigningCallback={onCancelPaymentCallback} title={title} />;
    }
    return <>{children}</>;
};

export default SigningContextFlow;
